module.exports = __webpack_public_path__ + "img/flag-tanzania.98741075.png";